import { create } from 'zustand';

const usePersonDocStore = create(set => ({
  selectedDocs: [],
  setSelectedDocs: values => set(() => ({ selectedDocs: values })),
  selectDocs: values =>
    set(state => {
      let docs;
      if (!Array.isArray(values)) {
        docs = [values];
      } else {
        docs = [...values];
      }
      const selectedDocs = [...state.selectedDocs];
      docs.forEach(doc => {
        if (!selectedDocs.find(e => e.id === doc.id)) {
          selectedDocs.push(doc);
        } else {
          const index = selectedDocs.findIndex(e => e.id === doc.id);
          if (index >= 0) {
            selectedDocs.splice(index, 1);
          }
        }
      });
      return { selectedDocs };
    }),
  clearSelectedDocs: () => set(() => ({ selectedDocs: [] }))
}));

export default usePersonDocStore;
